import React, { useEffect, useState } from 'react';
import { estadoAvisos, activarAvisos, desactivarAvisos, probarAvisos, necesitaInstalar } from '../services/avisosPedidos';
import { useToast } from '../context/ToastContext';
import { mensajeAmigable } from '../utils/errores';

// Tarjeta en Pedidos para activar que el celular suene cuando cae un pedido.
export default function AvisosPedidosCard() {
  const { mostrarToast } = useToast();
  const [estado, setEstado] = useState(null);
  const [ocupado, setOcupado] = useState(false);
  const refrescar = () => estadoAvisos().then(setEstado).catch(() => setEstado('apagados'));
  useEffect(() => { refrescar(); }, []);

  const hacer = async (fn, ok) => {
    setOcupado(true);
    try { const r = await fn(); if (ok) mostrarToast(typeof ok === 'function' ? ok(r) : ok, 'exito', 6000); } catch (e) { mostrarToast(mensajeAmigable(e), 'error', 8000); }
    setOcupado(false); refrescar();
  };

  if (estado === null) return null;
  const caja = { padding: '12px 14px', marginBottom: '14px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' };
  const btn = { padding: '8px 14px', borderRadius: '999px', border: 'none', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', fontSize: '13.5px' };

  if (estado === 'no-soportado' || necesitaInstalar()) {
    return (
      <div className="k-card" style={{ ...caja, background: '#FFF7ED' }}>
        <span style={{ fontSize: '13.5px' }}>🔔 Para que tu celular suene con cada pedido, abre Kontrol <b>desde el ícono instalado</b> en tu pantalla de inicio y activa los avisos aquí.</span>
      </div>
    );
  }
  if (estado === 'bloqueados') {
    return (
      <div className="k-card" style={{ ...caja, background: '#FEF2F2' }}>
        <span style={{ fontSize: '13.5px' }}>🔕 Los avisos están <b>bloqueados</b> en este navegador. Actívalos en los ajustes del celular (Notificaciones → Kontrol) y vuelve aquí.</span>
      </div>
    );
  }
  if (estado === 'activados') {
    return (
      <div className="k-card" style={{ ...caja, background: '#ECFDF5' }}>
        <span style={{ fontSize: '13.5px' }}>🔔 <b>Avisos activados en este dispositivo.</b> Te va a sonar cada pedido nuevo del catálogo, aunque Kontrol esté cerrado.</span>
        <span style={{ display: 'flex', gap: '6px' }}>
          <button disabled={ocupado} onClick={() => hacer(probarAvisos, (r) => (r.enviados ? 'Te mandé un aviso de prueba 🔔' : 'No se pudo entregar la prueba. Desactiva y vuelve a activar.'))} style={{ ...btn, background: '#fff', color: '#047857', border: '1px solid #A7F3D0' }}>Probar</button>
          <button disabled={ocupado} onClick={() => hacer(desactivarAvisos, 'Avisos desactivados en este dispositivo')} style={{ ...btn, background: 'transparent', color: '#6B7280' }}>Desactivar</button>
        </span>
      </div>
    );
  }
  return (
    <div className="k-card" style={{ ...caja, background: '#FDF2F8' }}>
      <span style={{ fontSize: '13.5px' }}>🔔 <b>¿Quieres que tu celular suene cuando caiga un pedido?</b> Actívalo en cada celular o compu donde atiendes.</span>
      <button disabled={ocupado} onClick={() => hacer(activarAvisos, '¡Listo! Te avisaremos cada pedido nuevo 🔔')} style={{ ...btn, background: 'var(--color-primario,#DB2777)', color: '#fff' }}>{ocupado ? 'Activando…' : 'Activar avisos'}</button>
    </div>
  );
}
